import _ from 'underscore';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';

function getRecommendationTypesFilter() {
  const recommendationList = [];
  recommendationList.push('NewLocationTarget');
  // add new types when new recommendation pilot
  if (_.size(recommendationList) === 0) {
    return 'true';
  }
  const filters = _.map(recommendationList, type => `RecommendationTypes/any(c:c eq Enum.RecommendationType'${type}')`);
  return `(${filters.join(' or ')})`;
}

export default class SettingsRepository {
  getDataSource() {
    return {
      type: 'jsdata',
      entity: TargetingSettingsContext.jsDataCampaign.Campaign,
      primaryKey: 'Id',
      options: {
        entitySet: TargetingSettingsContext.edmCampaign.currentAccount.Campaigns,
      },
    };
  }

  getQuery() {
    return {
      query: {
        $expand: _.compact([
          'CampaignCriterions',
          'Budget',
          'AssociatedExperiment',
        ]).join(', '),
      },
      options: {
        cacheResponse: false,
        entitySet: TargetingSettingsContext.edmCampaign.currentAccount.Campaigns,
        filterOptions: {
          odata: {
            custom: {
              RecommendationTypes: getRecommendationTypesFilter,
            },
          },
        },
      },
    };
  }
}
